import { connect } from 'react-redux';
import { createToolbarEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { openDialog } from '../../base/dialog/actions';
import { translate } from '../../base/i18n/functions';
import { IconMeter } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { isStageFilmstripEnabled } from '../functions';
import MaxStageParticipantsDialog from './MaxStageParticipantsDialog.web';
/**
 * React {@code Component} responsible for displaying a button in the toolbar
 * to open a dialog for selecting the maximum number of stage participants.
 *
 * @augments Component
 */
class MaxStageParticipantsButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.maxStageParticipants';
    label = 'toolbar.maxStageParticipants';
    tooltip = 'toolbar.maxStageParticipants';
    icon = IconMeter;
    /**
     * Handles clicking the button, and opens the dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('max.stage.participants'));
        dispatch(openDialog('MaxStageParticipantsDialog', MaxStageParticipantsDialog));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const stageFilmstripEnabled = isStageFilmstripEnabled(state);
    return {
        _maxStageParticipants: state['features/base/settings'].maxStageParticipants ?? 6,
        _stageFilmstripEnabled: stageFilmstripEnabled,
        visible: true // Always show the button
    };
}
export default translate(connect(_mapStateToProps)(MaxStageParticipantsButton));
